<template>
  <div :class="$style.container">
    <HgIcon v-if="isHgPlatform()" :icon="Icon.HeartOutline" size="x-large" />
    <FindingIcon v-else :class="$style.is24Icon" />
    <div :class="$style.headline" data-test-id="headline">
      {{ t('favourites.page.headline') }}
    </div>
    <div :class="$style.explanation" data-test-id="explanation">
      {{ t('favourites.page.explanation') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { HgIcon, Icon } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';

import FindingIcon from '@/assets/is24/finding.svg';
import { isHgPlatform } from '@/helpers/envService';

const { t } = useI18n();
</script>

<style module lang="scss">
@import '@/assets/variables';

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $color-grey-120;

  @include body-2;
}

.headline {
  margin-top: $space-100;
  font-weight: bold;
  text-align: center;
}

.explanation {
  margin-top: $space-50;
  text-align: center;
}

.is24Icon {
  width: 160px;
  height: 168px;
}
</style>
